import React from 'react';
import '../styles/footer.css';
import { Link } from "react-router-dom";
import { FaInstagram, FaEnvelope, FaPhone, FaLinkedin, FaTwitter,FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const homeNavLinks = [
    {label:"Home",href:"#home"},
    { label: "Services", href: "#services" },
    {label:"Unigs",href:"#unigs"},
    { label: "About Us", href: "#about" },
    { label: "Why Us", href: "#why-us" },
    { label: "Contact Us", href: "#contact-us" },
  ];

  return (
    <footer className="footer-section">
      <div className="footer-container">
      <div className="footer-logo-section">
      <div className="footer-logo">
       <img src="/assets/Logo.svg" alt="INBI Logo" />
      </div>
      <p className="company-description">Inventions Beyond Imagination.</p>
      </div>
        
      <div className="footer-links">
        <h3>Quick Links</h3>
          <ul>
            {homeNavLinks.map((link, index) => (
              <li key={index}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="footer-contact">
        <h3>Contact Us</h3>
        <div className="contact-info">
          <p>
            <a href="tel:7338057667" className="footer-map-link">
              <FaPhone className="icon" /> 7338057667
            </a>
          </p>

          <p>
            <a href="mailto:info@inbinextgen.com" className="footer-map-link">
              <FaEnvelope className="icon" /> info@inbinextgen.com
            </a>
          </p>

         <p>
          <FaMapMarkerAlt className="icon" />
          <a
          href="https://maps.app.goo.gl/kVBgwwq587AWmVLP8"
            target="_blank"
          rel="noopener noreferrer"
          className="footer-map-link"
          >
            Sakina Plaza, Mangalore Road, Karkala, Udupi District - 574104
          </a>
        </p>

      </div>
      <div className="social-links">
        <a href="" target="_blank" rel="noopener noreferrer" aria-label="Instagram"> <FaInstagram /> </a>
        <a href="mailto:info@inbinextgen.com"  aria-label="Email"><FaEnvelope /></a>
        <a href="https://www.linkedin.com/company/inbi-nextgen-innovations-private-limited/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
        <a href="https://x.com/inbinextgen" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
        </div>
      </div>
      </div>
      
      <div className="footer-bottom">
        <p>© 2025 INBI NextGen Innovations Private Limited. All rights reserved.</p>
        <div className="footer-legal">
        <Link to="/privacy">Privacy Policy</Link><span className="separator"> | </span><Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};export default Footer;